import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const products = [
  {
    id: 'sharemyimage',
    name: 'ShareMyImage',
    url: 'https://sharemyimage.com',
    domain: 'sharemyimage.com',
    color: 'from-blue-50 to-cyan-50',
    borderColor: 'border-blue-100',
    iconColor: 'text-blue-600',
    description: 'Lightning-fast free image hosting and sharing platform powered by global CDN.',
    features: ['Free Image Hosting', 'Direct Image Links', 'Global CDN Powered', 'Secure Sharing']
  },
  {
    id: 'abiggb',
    name: 'aBigGB',
    url: 'https://abiggb.com',
    domain: 'abiggb.com',
    color: 'from-purple-50 to-indigo-50',
    borderColor: 'border-purple-100',
    iconColor: 'text-purple-600',
    description: 'Enterprise-grade large file sharing and secure cloud storage solutions.',
    features: ['Large File Sharing', 'Cloud Storage', 'Secure Downloads', 'Business Transfer']
  },
  {
    id: 'shipassure',
    name: 'ShipAssure',
    url: 'https://shipassure.in',
    domain: 'shipassure.in',
    color: 'from-orange-50 to-red-50',
    borderColor: 'border-orange-100',
    iconColor: 'text-orange-600',
    description: 'Intelligent packaging video management to protect eCommerce sellers.',
    features: ['Video Management', 'Shipment Verification', 'Seller Protection', 'RTO Reduction']
  },
  {
    id: 'royalstar',
    name: 'Royal Star',
    url: 'https://royalstar.co.in',
    domain: 'royalstar.co.in',
    color: 'from-yellow-50 to-amber-50',
    borderColor: 'border-yellow-100',
    iconColor: 'text-yellow-600',
    description: 'Premium mobile accessories brand specializing in device protection.',
    features: ['Mobile Accessories', 'Premium Back Covers', 'Tempered Glass', 'Device Protection']
  }
];

const Products = () => {
  return (
    <section id="products" className="py-24 md:py-32 bg-slate-50 relative">
      <div className="container mx-auto px-6 max-w-7xl">
        
        <div className="text-center mb-16 md:mb-24">
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-6 font-sans">Our Ecosystem</h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Discover our suite of digital products designed to empower users and streamline business operations across various sectors.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {products.map((product, index) => (
            <motion.div 
              key={product.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`bg-white rounded-3xl p-8 border ${product.borderColor} shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group relative overflow-hidden`}
            >
              {/* Subtle background gradient on hover */}
              <div className={`absolute inset-0 bg-gradient-to-br ${product.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500`}></div>
              
              <div className="relative z-10 flex flex-col h-full">
                <div className="flex items-center gap-5 mb-6">
                  <div className="w-16 h-16 rounded-2xl bg-white shadow-md border border-slate-100 flex items-center justify-center p-2 overflow-hidden">
                    {/* Fetches crisp, high-resolution logos */}
                    <img 
                      src={`https://icon.horse/icon/${product.domain}`} 
                      alt={`${product.name} Logo`} 
                      className="w-full h-full object-contain"
                      loading="lazy"
                      onError={(e) => {
                        e.target.onerror = null; 
                        e.target.src = `https://www.google.com/s2/favicons?domain=${product.domain}&sz=256`;
                      }}
                    />
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900">{product.name}</h3>
                </div>
                
                <p className="text-slate-600 mb-8 text-lg">
                  {product.description}
                </p>

                <ul className="space-y-3 mb-10 flex-grow">
                  {product.features.map((feature, i) => (
                    <li key={i} className="flex items-center gap-3 text-slate-700 font-medium">
                      <div className={`w-6 h-6 rounded-full bg-white shadow-sm border border-slate-100 flex items-center justify-center ${product.iconColor}`}>
                        <SafeIcon name="Check" className="text-sm" />
                      </div>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <a 
                  href={product.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-between w-full px-6 py-4 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-semibold transition-all group/btn shadow-md"
                >
                  Visit Website
                  <SafeIcon name="ArrowRight" className="group-hover/btn:translate-x-1 transition-transform" />
                </a>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Products;